import React from "react";
import StyledContainer from "../../../partials/StyledContainer";
import "./Modal.scss";

function Modal({
  show = false,
  size = "sm",
  caption = "",
  content,
  showContinue = false,
  continueCaption,
  onContinueClick,
}) {
  if (show === false) {
    return null;
  }
  function setMarkup(content) {
    if (typeof content === "string") {
      return { __html: content };
    }
    return null;
  }
  return (
    <div className={"missionelements_Modal"}>
      <div className="missionelements_Modal_container">
        <div
          className={`missionelements_Modal_content 
                         ${
                           size === "sm"
                             ? "missionelements_Modal_content_sm "
                             : ""
                         }
                         ${
                           size === "md"
                             ? "missionelements_Modal_content_md "
                             : ""
                         }
                         ${
                           size === "lg"
                             ? "missionelements_Modal_content_lg "
                             : ""
                         }`}
        >
          <StyledContainer variant="light_blue" style={{ padding: 30 }}>
            <div dangerouslySetInnerHTML={setMarkup(content)} />
            {typeof content === "object" && content}
          </StyledContainer>
          {showContinue && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <button
                className="global-button "
                onClick={() => {
                  if (onContinueClick) {
                    onContinueClick();
                  }
                }}
              >
                {continueCaption}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;
